import React, {useState, useReducer, useCallback} from 'react';


export default React.createContext({});

export const useDomainsList = () => {
  const reducer = useCallback((state, action) => {
    const {item, type} = action;
    switch (type) {
      case 'addToHead':
        state.unshift(item);
        return state;
      case 'addToTail':
        state.push(item);
        return state;
      case 'clear':
        return [];
      default:
        throw new Error('unknown action type');
    }
  }, []);
  const [groupDomain, setCurrentGropuDomain] = useState(window.groupDomain || '.altervista.org');
  const [list, dispatch] = useReducer( reducer, []);
  const [secondaryList, dispatch2] = useReducer( reducer, []);
  const [domainExactMatchTld, dispatch3] = useReducer( reducer, []);
  const [selected, setCurrentSelected] = useState(null);
  const [thirdLevel, setCurrentThirdLevel] = useState(null);
  const [searchState, setSearchState] = useState('idle');
  const [secondarySearchState, setSecondary] = useState('idle');
  const [requestedTld, setTld] = useState(groupDomain);
  const [primaryTld, setCurrentPrimaryTld] = useState([]);
  const [secondaryTld, setCurrentSecondaryTld] = useState([]);
  const setSelected = useCallback(item => {
    if (item) {
      window.sessionStorage.setItem('altervistaSelectedItem', JSON.stringify(item));
    } else {
      window.sessionStorage.removeItem('altervistaSelectedItem');
    }
    setCurrentSelected(item);
  }, []);
  const getSelected = useCallback( () => {
    if (selected) return selected;
    let savedItem = window.sessionStorage.getItem('altervistaSelectedItem');
    if (savedItem) return JSON.parse(savedItem);
    return null
  }, []);
  const clearSelected = useCallback( () => {
    setCurrentSelected(null);
  }, []);
  const setThirdLevel = useCallback(item => {
    setCurrentThirdLevel(item);
  }, []);
  const setSearch = useCallback(searchState => {
    setSearchState(searchState)
  }, []);
  const setSecondarySearch = useCallback(searchState => {
    setSecondary(searchState)
  }, []);
  const setRequestedTld = useCallback(tld => {
    setTld(tld)
  }, []);

  function addToHead(item) {
    dispatch({type: 'addToHead', item: item})
  }
  function addToTail(item) {
    dispatch({type: 'addToTail', item: item})
  }
  function clear() {
    dispatch({type: 'clear'});
    setThirdLevel(null);
  }
  function addToHead2(item) {
    dispatch2({type: 'addToHead', item: item})
  }
  function addToTail2(item) {
    dispatch2({type: 'addToTail', item: item})
  }
  function clear2() {
    dispatch2({type: 'clear'});
    setThirdLevel(null);
  }
  function empty() {
    dispatch2({type: 'clear'});
  }
  function addToHead3(item) {
    dispatch3({type: 'addToHead', item: item})
  }
  function clear3() {
    dispatch3({type: 'clear'});
  }
  return {
    groupDomain,
    list, addToHead, addToTail, clear,
    secondaryList, addToHead2, addToTail2, clear2, empty,
    domainExactMatchTld, addToHead3, clear3,
    thirdLevel, setThirdLevel,
    searchState, setSearch,
    secondarySearchState, setSecondarySearch,
    getSelected, setSelected, clearSelected,
    requestedTld, setRequestedTld,
    primaryTld, setCurrentPrimaryTld,
    secondaryTld, setCurrentSecondaryTld
  }
};

export const useFormValues = () => {
  const reducer = useCallback((state, action) => {
    const {type, field, value, newState} = action;
    switch (type) {
      case 'setValue':
        state[field] = value;
        return state;
      case 'set':
        return newState;
      case 'clear':
        return {};
      default:
        throw new Error('unknown action type');
    }
  }, []);
  const [values, dispatch] = useReducer(reducer, {});
  const [recaptchaRef, setCurrentRecaptchaRef] = useState(null);
  const getValue = (name) => {
    if (values[name]) return values[name];
    let savedValues = window.sessionStorage.getItem(`alter-${name}`);
    if (savedValues) return JSON.parse(savedValues);
    return undefined;
  };
  const getAllValues = () => {
    if (Object.keys(values).length === 0) {
      for (name in sessionStorage) {
        if (name.startsWith('alter-')) {
          values[name.substring(6)] = JSON.parse(sessionStorage[name]);
        }
      }
    }
    return values;
  };
  const clear = () => {
    dispatch({type: 'clear'})
  };
  const set = (newValues) => {
    for (let key in newValues) {
      if (key !== 'token' && key !== 'g-recaptcha-response') {
        if (newValues[key]) {
          window.sessionStorage.setItem(`alter-${key}`, JSON.stringify(newValues[key]));
        } else {
          window.sessionStorage.removeItem(`alter-${key}`);
        }
      }
    }
    dispatch({type: 'set', newState: newValues})
  };
  const setValue = (fieldName, fieldValue) => {
    if (fieldValue) {
      window.sessionStorage.setItem(`alter-${fieldName}`, JSON.stringify(fieldValue));
    } else {
      window.sessionStorage.removeItem(`alter-${fieldName}`);
    }
    dispatch({type: 'setValue', field: fieldName, value: fieldValue})
  };
  const setRecaptchaRef = useCallback(ref => {
    setCurrentRecaptchaRef(ref);
  }, []);
  return {
    values, set, setValue, getValue, getAllValues, clear,
    recaptchaRef, setRecaptchaRef
  }
};

export const useTransitions = () => {
  const [current, setCurrentTransition] = useState('pop');
  const setCurrent = useCallback(transition => {
    setCurrentTransition(transition);
  }, []);
  return {current, setCurrent}
};

export const useFacebookConnect = () => {
  const [userIsConnected, setConnected] = useState(false);
  const [fbData, setCurrentFbData] = useState(null);
  const setConnection = useCallback(loaded => {
    setConnected(loaded);
  }, []);
  const setFbData = useCallback(data => {
    setCurrentFbData(data);
  }, []);
  return {
    userIsConnected, setConnection,
    fbData, setFbData
  }
};

export const useFormError = () => {
  const reducer = useCallback((state, action) => {
    const {item, type} = action;
    switch (type) {
      case 'addToHead':
        state.unshift(item);
        return state;
      case 'addToTail':
        state.push(item);
        return state;
      case 'clear':
        return [];
      default:
        throw new Error('unknown action type');
    }
  }, []);
  const [list, dispatch] = useReducer( reducer,[]);

  function addToHead(item) {
    dispatch({type: 'addToHead', item: item})
  }
  function addToTail(item) {
    dispatch({type: 'addToTail', item: item})
  }
  function clear() {
    dispatch({type: 'clear'});
  }
  return {list, addToHead, addToTail, clear}
};